import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getAccessToken } from '@repo/token-storage';
import { Link, createRootRouteWithContext, redirect } from '@tanstack/react-router';
// Public routes that don't require authentication
const PUBLIC_ROUTES = [
    '/login',
    '/auth/callback',
    '/403',
    '/404',
    '/500'
];
export const Route = createRootRouteWithContext()({
    beforeLoad: async (param)=>{
        let { location } = param;
        const isPublicRoute = PUBLIC_ROUTES.some((route)=>location.pathname.startsWith(route));
        // If not a public route, check for token
        if (!isPublicRoute) {
            const token = getAccessToken();
            if (!token) {
                throw redirect({
                    to: '/login',
                    search: {
                        redirect: location.href
                    }
                });
            }
        }
        // If has token but trying to access login, redirect to home
        if (getAccessToken() && location.pathname === '/login') {
            throw redirect({
                to: '/'
            });
        }
    },
    notFoundComponent: ()=>{
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    children: "This is the notFoundComponent configured on root route"
                }),
                /*#__PURE__*/ _jsx(Link, {
                    to: "/",
                    children: "Start Over"
                })
            ]
        });
    }
});
